
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title: "Footer (pied de page) d'un site internet, guide et 14 exemples",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez le guide complet de A à Z sur les footers de site internet avec 14 exemples inspirants. Apprenez à optimiser cette section  pour votre site.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            "Footer (pied de page) d'un site internet, guide et 14 exemples",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "Découvrez le guide complet de A à Z sur les footers de site internet avec 14 exemples inspirants. Apprenez à optimiser cette section  pour votre site.",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/og/og-facebook-apropos.jpg"),
        // },
      ],
    };
  },
};
